var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLargeConfirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 34.5,
    stroke: "#37984D",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_378_2608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.3705 25.9995C52.2076 26.8296 52.2076 28.171 51.3705 29.0011L34.2277 46.0011C33.3906 46.8312 32.0379 46.8312 31.2009 46.0011L22.6276 37.5011C21.7908 36.671 21.7908 35.3296 22.6276 34.4995C23.4645 33.6695 24.8212 33.6695 25.6583 34.4995L32.654 41.4921L48.3438 25.9995C49.1808 25.1681 50.5335 25.1681 51.3705 25.9995Z",
    fill: "#37984D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_378_2608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 34,
    fill: "white",
    transform: "translate(22 19)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeConfirm);
export default __webpack_public_path__ + "static/media/largeConfirm.e9e54f865fec684ff6c5403d16eef9da.svg";
export { ForwardRef as ReactComponent };